var render, staticRenderFns
import script from "./standbylist.vue?vue&type=script&lang=js&"
export * from "./standbylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1026a5a",
  null
  
)

export default component.exports